import { useAddShiplist } from '@ais-ui/api';
import { SaveShiplistDialog } from './SaveShiplistDialog';
import { MutateShiplistProvider } from './MutateShiplistContext';

interface CreateShiplistProps {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

export function CreateShiplist(props: CreateShiplistProps) {
  const { mutate } = useAddShiplist();

  return (
    <MutateShiplistProvider
      showDialog={props.showDialog}
      setShowDialog={props.setShowDialog}
      shiplist={undefined}
      action={'create'}
      mutate={mutate}
    >
      <SaveShiplistDialog></SaveShiplistDialog>
    </MutateShiplistProvider>
  );
}
